import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const Resources = () => {
    const resources = [
        { title: 'Academic Calendar 2026-2027', type: 'PDF', size: '2.5 MB', category: 'Academic' },
        { title: 'Syllabus - Class 10', type: 'PDF', size: '1.8 MB', category: 'Syllabus' },
        { title: 'Syllabus - Class 12 Science', type: 'PDF', size: '2.1 MB', category: 'Syllabus' },
        { title: 'Examination Schedule', type: 'PDF', size: '850 KB', category: 'Examination' },
        { title: 'School Circular - January 2026', type: 'PDF', size: '650 KB', category: 'Circular' },
        { title: 'Holiday List 2026-2027', type: 'PDF', size: '400 KB', category: 'General' },
        { title: 'Parent Handbook', type: 'PDF', size: '5.2 MB', category: 'General' },
        { title: 'Code of Conduct', type: 'PDF', size: '1.2 MB', category: 'Policy' },
        { title: 'Uniform Guidelines', type: 'PDF', size: '800 KB', category: 'General' },
    ];

    const categories = [...new Set(resources.map(r => r.category))];

    return (
        <div className="min-h-screen pt-24" data-testid="resources-page">
            <section className="relative py-20 overflow-hidden bg-gradient-to-br from-violet-900 via-purple-800 to-blue-900 text-white">
                <div className="container mx-auto px-4 md:px-8 text-center">
                    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
                        <h1 className="font-outfit font-bold text-5xl md:text-7xl mb-6 text-white">Resources & Downloads</h1>
                        <p className="font-dm-sans text-xl md:text-2xl max-w-3xl mx-auto text-white/95">Access important documents and study materials</p>
                    </motion.div>
                </div>
            </section>

            <section className="py-24 bg-white">
                <div className="container mx-auto px-4 md:px-8">
                    {categories.map((category, catIndex) => (
                        <div key={category} className="mb-16 last:mb-0">
                            <h2 className="font-outfit font-bold text-3xl text-primary mb-8">{category}</h2>
                            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {resources.filter(r => r.category === category).map((resource, index) => (
                                    <motion.div key={index} className="bg-red-600 rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all group" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }} data-testid={`resource-card-${catIndex}-${index}`}>
                                        <FileText className="w-12 h-12 text-primary mb-4" />
                                        <h3 className="font-outfit font-bold text-lg mb-2">{resource.title}</h3>
                                        <div className="flex items-center justify-between text-sm text-muted-foreground mb-4">
                                            <span>{resource.type}</span>
                                            <span>{resource.size}</span>
                                        </div>
                                        <Button className="w-full" size="sm">
                                            <Download className="w-4 h-4 mr-2 text-black" />
                                            <p className='text-black'>Download</p>
                                        </Button>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Resources;